import React from 'react';
import { useAndroidDetection } from '../../hooks/useAndroidDetection';
import QRCode from '../ui/QRCode';
import './Header.css';

const Header: React.FC = () => {
  const isAndroid = useAndroidDetection();

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">
            🎮 JustFun
          </h1>
          <p className="app-subtitle">Brain Training Games</p>
        </div>
        
        <div className="header-right">
          {isAndroid && (
            <div className="android-promotion">
              <QRCode 
                url="https://play.google.com/store/apps/details?id=com.sssk.justfun"
                title="Download Android App"
                size={150}
              />
            </div>
          )}
        </div>
      </div>
      
      <div className="header-description">
        <p>Play puzzle games, train your brain, and have fun! Try our games below and get the full experience on Android.</p>
      </div>
    </header>
  );
};

export default Header;
